import axios from 'axios';
import { store } from '@/store';

const http = {
  authHandler: null,
  mount() {
    axios.defaults.baseURL = import.meta.env.VITE_API_URL;
    axios.interceptors.response.use(
      (response) => {
        if (response.status === 429) {
          console.log("too many requests, logging user out.");
          store.dispatch('user/logout').then(() => {
            console.log("user logged out.");
          });
        }
        return response;
      },
      (error) => {
        if (error.status === 429) {
          console.log("unhappy path");
          console.log("too many requests, logging user out.");
          store.dispatch('user/logout').then(() => {
            console.log("user logged out.");
          });
        }
        return error;
      });

    this.authHandler = axios.interceptors.request.use((config) => {
      const token = store.getters['user/token'];

      if (token !== null) {
        config.headers.Authorization = `Bearer ${ token }`;
      }

      return config;
    });
  },
  unmount() {
    axios.interceptors.request.eject(this.authHandler);
  },
};

export {
  http,
};